import React from 'react';
import { FormattedMessage } from 'react-intl';

export const NotFoundPage = (): React.ReactElement => {
  return (
    <div>
      <FormattedMessage id="errors.page-not-found" />
    </div>
  );
};
